<div *ngIf="(getAppliedFilters$|async).length" class="wrapper">
    <b class="center">Filtros aplicados <span class="icon-span"><i class="material-symbols-rounded">filter_alt</i></span>:</b>

    <label (click)="removeFilter(filter)" *ngFor="let filter of getAppliedFilters$|async">
        {{filter.label}} <span [class.disabled]="!filter.canDelete" class="icon-span delete"><i class="material-symbols-rounded">close</i></span>
    </label>
</div>